import React from 'react';
import { Outlet } from 'react-router-dom';
import StepProgressBar from './StepProgressBar';

const OnboardingShell: React.FC = () => {
  return (
    <div className="onboarding-shell">
      {/* Brand header */}
      <header className="onboarding-header">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <img
                src="/logo192.png"
                alt="Mentorgain"
                className="onboarding-logo"
              />
              <span className="onboarding-brand">Mentorgain</span>
            </div>
{/* Right side intentionally empty */}
          </div>
        </div>
      </header>

      {/* Step progress */}
      <div className="container">
        <div className="onboarding-progress-wrapper">
          <StepProgressBar />
        </div>
      </div>

      {/* Page content */}
      <main className="onboarding-content">
        <Outlet />
      </main>

      {/* Trust footer */}
      <footer className="onboarding-footer">
        <div className="container text-center">
          <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap">
            <span className="trust-signal">
              <i className="fa-solid fa-shield-halved" />
              SSL Encrypted
            </span>
            <span className="trust-signal">
              <i className="fa-solid fa-lock" />
              SOC 2 Compliant
            </span>
            <span className="trust-signal">
              <i className="fa-solid fa-user-shield" />
              GDPR Compliant
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OnboardingShell;
